import { Typography, TypographyProps } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

interface EmptyCellProps {
  variant?: TypographyProps['variant'];
}

export function EmptyCell({ variant = 'body-xs' }: EmptyCellProps) {
  return (
    <Typography variant={variant} sx={{ color: COLORS.TEXT.SECONDARY }}>
      None
    </Typography>
  );
}
